import fileUploadImg from 'static/images/file-upload.svg';
import crossImg from 'static/images/close.svg';
import viewIcon from 'static/images/view.svg';

import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { END } from 'redux-saga';
import { FILE_MSG, FILE_MSG_WITH_EXT } from 'components/Onboarding/Mle/mle.constants';

const MainContainer = styled.div`
    overflow: hidden;
    width: 100%;
    min-height: 54px;
    max-height: 90px;
`;

const Icon = styled.img`
    width: ${props => (props.size === 'small' ? '20px' : '30px')};
    height: ${props => (props.size === 'small' ? '20px' : '30px')};
    margin-right: ${props => (props.marginRight ? props.marginRight : 0)};
    cursor: ${props => (props.isActionIcon ? 'pointer' : '')};
`;

// Styled components
const DropzoneContainer = styled.div`
    border: 1px solid #c3c1bf;
    border-radius: 10px;
    height: auto;
    width: 100%;
    cursor: pointer;
    background: ${props => (props.layout === 'vertical' ? '#eff2f9' : '100px')};
`;

const FileList = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const StyledFile = styled.div`
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid #efefef;
    border-radius: 8px;
    margin: 15px 15px 0 0;
    position: relative;
`;

const StyledSpan = styled.span`
    color: #000;
    curson: default;!important;
`;

const StyledComponent = styled.div`
    display: flex;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    flex-direction: ${props =>
        props.layout === 'vertical' ? 'column' : 'row'};
`;
const StyledImg = styled.img`
    margin-right: 20px;
    padding: 5px;
`;

const StyledButton = styled.div`
    z-index: 10;
    color: #ff7744;
    border-radius: 4px;
    font-family: 'lato-regular';
    font-size: 14px;
    font-weight: 500;
    padding: 12px 20px;
    margin: 0 auto;
`;

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
    /* text-transform: capitalize; */
`;

const FileNameSpan = styled.span`
    margin-right: 5px;
`;

const CloseIcon = styled.img`
    top: -10px;
    right: -10px;
    position: absolute;
    cursor: pointer;
`;

// Redux-Form field component
const MultiUploadUrlHandling = ({
    input: { value, onChange },
    onFileListChange,
    layout,
    subtitle,
    accept,
    fileList,
    fileListUrl,
    handleViewImages,
    maxSize,
    meta,
    maxFiles = 1,
    id,
    isViewMode,
    hideErrors,
    error
}) => {
    const [errorMessage, setErrorMessage] = useState('');

    const removeFile = file => () => {
        const newFiles = [...fileList];
        newFiles.splice(newFiles.indexOf(file), 1);

        onChange(newFiles);
        onFileListChange(newFiles);
    };

    const onDrop = useCallback(
        (acceptedFiles, fileRejections) => {


            if (fileRejections && fileRejections.length > 0) {
                let errorMsg = fileRejections.filter(file => file?.errors?.length > 0)?.map(file => file?.errors?.[0]?.message);

                setErrorMessage(errorMsg?.join('. '));
            }
            const newFiles = [...fileList, ...acceptedFiles];

            if (acceptedFiles.length + fileListUrl.length > maxFiles) {

                let errorMssg = "You can upload a maximum of "+maxFiles+" files";
                setErrorMessage(errorMssg);
                return;
            }
            setErrorMessage('');
            onChange(newFiles);
            // only setting up new files in file list component
            onFileListChange(acceptedFiles);
        },
        [onChange, onFileListChange]
    );

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept,
        maxSize,
        maxFiles
    });

    const handleViewFileClick = (e) => {
        e.preventDefault(); // Prevent file input trigger when clicking "View File"
        handleViewImages(); // Execute the "View File" logic
    };


    let uploadMarginUpdateClass = (!hideErrors && (error || (meta && meta.error && meta.touched))) ? 'update-width' : '';

    return (
        <MainContainer layout={layout}>

            <DropzoneContainer layout={layout}>
                <StyledComponent layout={layout}>
                    <div {...getRootProps()} style={{width: '100%'}}>
                        <StyledComponent layout={layout}>

                        {fileListUrl?.length > 0 &&
                            <>
                                <div style={{display:'flex', justifyContent: 'space-between', width: '100%', padding: '7px 0'}}>
                                    <div style={{padding: '12px 20px'}} onClick={e => e.stopPropagation()}>
                                        <StyledSpan layout={layout}>
                                            {fileListUrl.length} {fileListUrl.length === 1 ? 'file' : 'files' }
                                        </StyledSpan>
                                    </div>
                                    {!isViewMode &&
                                    <StyledButton>Browse</StyledButton>
                                    }
                                </div>
                            </>
                        }
                        {fileListUrl?.length === 0 &&
                            <>
                                <StyledImg
                                    src={fileUploadImg}
                                    alt="fileUploadImg"
                                    layout={layout}
                                    style={{maxWidth: 50}}
                                />
                                <StyledButton layout={layout} style={{"padding-right": "72px"}}>Browse</StyledButton>
                            </>
                        }
                            <input {...getInputProps()} id={id} disabled={isViewMode} />
                        </StyledComponent>
                    </div>
                    {!!fileListUrl?.length &&
                        <>
                            <StyledButton onClick={handleViewFileClick} style={{margin: 0, whiteSpace: 'nowrap'}}>
                                View
                            </StyledButton>
                        </>
                    }
                </StyledComponent>
            </DropzoneContainer>

            {/* {value && (
                <FileList layout={layout}>
                    {value.map((file, index) => (
                        <StyledFile key={index}>
                            <FileNameSpan>{file.name}</FileNameSpan>
                            <CloseIcon
                                src={crossImg}
                                alt="cross"
                                onClick={removeFile(file)}
                            ></CloseIcon>
                        </StyledFile>
                    ))}
                </FileList>
            )} */}
            {(meta?.error && meta?.touched) || errorMessage ? (
                <ErrorWrapper>{meta?.error || errorMessage}</ErrorWrapper>
            ) : null}
            <span className={`info-element ${uploadMarginUpdateClass}`}>{FILE_MSG_WITH_EXT + "pdf, jpg, jpeg, png, svg. "+maxFiles+" Files are allowed."} </span>
        </MainContainer>
    );
};

export default MultiUploadUrlHandling;

MultiUploadUrlHandling.propTypes = {
    customClass: PropTypes.string,
    handleChange: PropTypes.func,
    labelField: PropTypes.string,
    options: PropTypes.array,
    valueField: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object,
    wrapperClass: PropTypes.string,
    layout: PropTypes.string,
    subtitle: PropTypes.string,
    onFileListChange: PropTypes.func,
    fileList: PropTypes.array,
};
